<div class="px-4">

  <div class=" sec-title" style="font-weight: 600;">
    Please select an event
  </div>

  <!-- Error Message Display -->
  @if(errorMessage){
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
    <strong>Error!</strong> {{errorMessage}}
    <button type="button" class="btn-close" (click)="errorMessage = null"></button>
  </div>
  }

  <!-- Loading Spinner -->
  @if(loading){
  <div class="d-flex justify-content-center my-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }

  <div class="row">
    @if(!loading && events.length == 0 && !errorMessage){
    <div class="d-flex">
      <span class="no-data">No Active Events</span>
    </div>
    }

    <div class="col-md-4 mt-2 pointer" *ngFor="let item of events" (click)="selectEvent(item)">
      <div class="cuscard ">
        <div class="px-2 d-flex">
          <div class="mt-2 livesvg">
            <i class="fa fa-circle text-danger-glow blink" style="font-size: 10px;"></i>
            <span class="mx-1" style="font-weight: 500;font-size: 11px;">Live</span>
          </div>
          <div class="mt-2 cuscard-event">
            {{item['event_name']}}
          </div>
          <div>
          </div>
        </div>
        <img class="cuscard-img" [src]="item['image_url']" width="150" height="90" />
        <div class="cuscard-footer">
          <span style="font-size: 15px;">{{item['event_location']}}</span>
          <span class="mt-1" style="font-size: 13px;">{{item['event_date']}}</span>
        </div>
      </div>
    </div>
  </div>
</div>